<template>
  <main class="landing">
    <Hero />
    <NftPlayground />
    <Features />
    <MeetYourSideKick />
    <Rarity />
    <Minting />
    <SneakerLegacy />
    <Milestones />
    <Roadmap />
    <Faq />
  </main>
</template>
<script>
import Faq from '../layouts/home/Faq.vue';
import Features from '../layouts/home/Features.vue';
import Hero from '../layouts/home/Hero.vue';
import MeetYourSideKick from '../layouts/home/MeetYourSideKick.vue';
import Milestones from '../layouts/home/Milestones.vue';
import Minting from '../layouts/home/Minting.vue';
import NftPlayground from '../layouts/home/NftPlayground.vue';
import Rarity from '../layouts/home/Rarity.vue';
import Roadmap from '../layouts/home/Roadmap.vue';
import SneakerLegacy from '../layouts/home/SneakerLegacy.vue';

export default {
  name: 'Landing',
  components: {
    Hero,
    NftPlayground,
    Features,
    MeetYourSideKick,
    Rarity,
    Minting,
    SneakerLegacy,
    Roadmap,
    Faq,
    Milestones,
  },
};
</script>
<style lang="scss">
@import "../assets/styles/fontstyle.css";
.video-js {
  width: 100vw;
  height: 166%;
  margin-top: -12vw;
}
.video-js .vjs-big-play-button {
  display: none !important;
}
.vjs-poster {
  object-fit: contain !important;
  image-rendering: optimizeQuality !important;
  background-position: 50% 50% !important;
  right: 0;
  left: 0;
  bottom: 0;
  // top: 20vw;
  top: 12vw;
  height: 35vw;
  @media (max-width: 769px) {
    width: 100%;
    background-position: 50% 50% !important;
    height: 60vw !important;
    bottom: unset;
    top: 0vw;
    background: url("../assets/rebrand/home/poster.png");
    z-index: 100;
    object-fit: contain !important;
    background-size: auto 50vw;
    background-repeat: no-repeat;
  }
}
</style>
<style lang="scss">
@import "../assets/styles/landing.scss";
.sneaker-legacy {
  .carousel,
  .carousel-inner,
  .carousel-item {
    height: 64vw !important;
    .carousel-caption {
      position: relative;
      right: 0;
      bottom: 0;
      left: 0;
      top: 0;
      z-index: 10;
      padding-top: 0;
      padding-bottom: 0;
      color: #fff;
      text-align: unset;
    }
    .carousel-inner {
      overflow: hidden;
    }
  }
  .carousel-indicators {
    margin: 0 auto 5vw;

    li {
      background-color: transparent;
      width: 6vw;
      height: 0.3vw;
      margin: 0 1.5vw;
      width: 6vw;
      height: 0.5vw;
      position: relative;
      &:focus {
        outline: 0 !important;
        box-shadow: none !important;
        border-color: transparent !important;
      }
      &::before {
        content: "";
        position: absolute;
        top: 0vw;
        left: 0vw;
        z-index: 1;
        border: 1px solid #000000;
        width: 6vw;
        height: 0.5vw;
      }
      &.active {
        &::after {
          content: "";
          position: absolute;
          top: -0.4vw;
          left: -0.5vw;
          background: rgb(255, 94, 0);
          height: 1.3vw;
          width: 7vw;
          z-index: 0;
        }
      }
    }
  }
}
</style>
